/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import { useQuery } from '@tanstack/react-query';
import { finopsService } from '../services/finopsApi';
import { useOrgStore } from '../store/orgStore';

export interface FinopsPermissions {
  isManager: boolean;
  isOperator: boolean;
  canManageGrants: boolean;
  isLoading: boolean;
}

// useFinopsPermissions fetches the caller's effective FinOps tier for the
// current org context. Keyed by the selected org so switching orgs refetches.
// While loading or on error it returns all-false, so action buttons never
// flash in before permission is known.
export function useFinopsPermissions(): FinopsPermissions {
  const selectedOrgId = useOrgStore((s) => s.selectedOrgId);

  const { data, isLoading } = useQuery({
    queryKey: ['finops-me', selectedOrgId],
    queryFn: async () => (await finopsService.getMe()).data,
    staleTime: 60_000,
  });

  return {
    isManager: data?.is_manager ?? false,
    isOperator: data?.is_operator ?? false,
    canManageGrants: data?.can_manage_grants ?? false,
    isLoading,
  };
}
